import { render, staticRenderFns } from "./LeadRouting.vue?vue&type=template&id=71b7587a&"
import script from "./LeadRouting.vue?vue&type=script&lang=js&"
export * from "./LeadRouting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports